import React from 'react';
import { Star } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function Testimonials() {
  const reviews = [{
    name: 'Marsha van Lanen',
    role: 'Hondenouder',
    text: 'Veel kennis opgedaan over het gedrag van honden, zodat ik de hondentaal beter kan lezen en mijn hond veel beter begrijp.',
    rating: 5,
    photo: 'https://images.unsplash.com/photo-1596815064285-45ed8a9c0463?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Truus van Everdingen',
    role: 'Hondenouder',
    text: 'De inzichten van Amee helpen ons enorm om hem beter te begrijpen. Plus alle leuke dingen die we leerden om zijn leven leuker te maken.',
    rating: 5,
    photo: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=150&q=80'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-145">
      <div className="max-w-5xl mx-auto" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4" data-id="element-148">
            Benieuwd hoe andere baasjes het hebben ervaren?
          </h2>
          <p className="text-lg text-gray-500" data-id="element-149">
            Lees de ervaringen van hondenbaasjes die je voorgingen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-150">
          {reviews.map((review, index) => <div key={index} className="bg-white rounded-3xl p-8 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-gray-100 flex flex-col h-full relative" data-id="element-151">
              <div className="absolute -top-4 left-8 bg-brand-mint text-white w-8 h-8 flex items-center justify-center rounded-full font-serif text-2xl leading-none" data-id="element-152">
                "
              </div>
              <div className="flex gap-1 mb-4 pt-2" data-id="element-153">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-mint text-brand-mint" data-id="element-154" />)}
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-155">
                "{review.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-156">
                <img src={review.photo} alt={review.name} className="w-12 h-12 rounded-full object-cover border-2 border-brand-mint/20" data-id="element-157" />
                <div data-id="element-158">
                  <p className="font-bold text-slate-800" data-id="element-159">{review.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-160">{review.role}</p>
                </div>
              </div>
            </div>)}
        </div>

        <SectionCTA data-id="element-161" />

        {/* Trustpilot Grid Widget */}
        <div className="mt-16" data-id="element-162">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="539adbd6dec7e10e686debee" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="500px" data-style-width="100%" data-token="19d27b27-5b91-4674-999a-687b97446c00" data-stars="4,5" data-review-languages="nl" data-id="element-163">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-164">
              Trustpilot
            </a>
          </div>
        </div>
      </div>
    </section>;
}